export default "__VITE_ASSET__DF7v$hgg__"